import * as React from "react";
import * as TogglePrimitive from "@radix-ui/react-toggle";
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils";

const toggleVariants = cva(
    "inline-flex items-center justify-center rounded-lg text-sm font-medium ring-offset-background transition-all duration-200 ease-out hover:bg-muted hover:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-indigo-600 data-[state=on]:text-white data-[state=on]:shadow-lg data-[state=on]:scale-[1.02] data-[state=on]:border-indigo-500",
    {
        variants: {
            variant: {
                default: "bg-transparent",
                outline:
                    "border-solid border border-slate-600 bg-slate-800/60 hover:bg-slate-700/60 hover:border-slate-500",
            },
            size: {
                default: "h-16 py-0 px-3",
                sm: "h-9 px-2.5",
                lg: "h-11 px-5",
            },
        },
        defaultVariants: {
            variant: "default",
            size: "default",
        },
    }
);

const Toggle = React.forwardRef(
    ({ className, variant, size, ...props }, ref) => (
        <TogglePrimitive.Root
            ref={ref}
            className={cn(toggleVariants({ variant, size, className }))}
            {...props}
        />
    )
);

Toggle.displayName = TogglePrimitive.Root.displayName;

export { Toggle, toggleVariants };